import * as React from "react";

import { Loading } from "../../Common";

import {
  useProductListLoadingState,
  usePlpPresenterForTheFilterMenu_Mobile,
} from "../providers";

export const AppLoading: React.FunctionComponent = () => {
  const { isLoading: isTheProductListLoading } = useProductListLoadingState();
  const {
    shouldShowTheFilterMenu_onMobile: isTheMobileFilterMenuActiveRightNow,
  } = usePlpPresenterForTheFilterMenu_Mobile();

  const isLoading = React.useMemo(() => {
    return isTheProductListLoading && !isTheMobileFilterMenuActiveRightNow;
  }, [isTheProductListLoading, isTheMobileFilterMenuActiveRightNow]);

  if (!isLoading) {
    return null;
  }

  return <Loading />;
};
